<template>
  <div class="llp">

    <!-- traka -->
    <div class="llp-traka">
      <div>
        <div class="llp-naslov">Provjera obračuna amortizacije</div>
        <div class="llp-pod">
          Sva osnovna sredstva kroz sve godine · prijenos stanja, obračun amortizacije i odstupanja
        </div>
      </div>
      <div class="llp-razmak"></div>
      <button type="button" class="llp-b llp-b-bijeli" title="Natrag na popis osnovnih sredstava" @click="natrag">&larr; Natrag na popis</button>
      <button type="button" class="llp-b llp-b-bijeli" :disabled="!sredstva.length" @click="izvezi">Excel</button>
      <button type="button" class="llp-b llp-b-bijeli" :loading="trazim" @click="ucitaj">Osvježi</button>
    </div>

    <!-- odabir -->
    <div class="llp-odabir">
      <v-row dense align="center">
        <v-col cols="12" md="3">
          <v-select
            v-model="filtar"
            :items="filtri"
            item-value="vrijednost"
            item-text="naziv"
            label="Prikaži"
            dense hide-details outlined
            @change="primijeni"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="trazi"
            label="Traži po šifri ili nazivu"
            dense hide-details outlined clearable
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="5" class="llp-mala">
          Nalazi su na dvije razine: <b class="llp-crveno">greška</b> znači da račun ne stoji,
          <b class="llp-zuto">napomena</b> je poslovna odluka ili događaj (rashod, izostanak
          amortizacije, preračun u eure) i ne mora biti pogrešna.
        </v-col>
      </v-row>
    </div>

    <div v-if="greska" class="llp-greska">{{ greska }}</div>

    <!-- brojke -->
    <div v-if="sazetak" class="llp-brojke">
      <div><span>Sredstava</span><b>{{ sazetak.sredstava }}</b></div>
      <div><span>Godina-redaka</span><b>{{ sazetak.godina }}</b></div>
      <div :class="sazetak.sGreskom ? 'llp-los' : 'llp-ok'"><span>S greškom</span><b>{{ sazetak.sGreskom }}</b></div>
      <div><span>S napomenom</span><b>{{ sazetak.sNapomenom }}</b></div>
      <div><span>Godina bez obračunate amortizacije</span><b>{{ sazetak.godinaBezAmortizacije }}</b></div>
      <div class="llp-istaknuto">
        <span>Trebalo obračunati, a nije</span><b>{{ novac(sazetak.neobracunato) }}</b>
      </div>
      <div v-if="sazetak.manjeObracunato"><span>Obračunato manje nego po stopi</span><b>{{ novac(sazetak.manjeObracunato) }}</b></div>
    </div>

    <!-- nalazi po vrsti -->
    <div v-if="sazetak && sazetak.poVrsti.length" class="llp-vrste">
      <button
        v-for="v in sazetak.poVrsti" :key="v.vrsta" type="button"
        class="llp-znak" :class="[v.razina === 'greska' ? 'llp-znak-greska' : 'llp-znak-napomena', {'llp-znak-odabran': filtar === 'vrsta:' + v.vrsta}]"
        :title="opisVrste(v.vrsta)"
        @click="filtrirajVrstu(v.vrsta)"
      >{{ nazivVrste(v.vrsta) }} <b>{{ v.broj }}</b></button>
    </div>

    <div v-if="trazim" class="llp-prazno">Provjeravam…</div>
    <div v-else-if="!redovi.length" class="llp-prazno">
      {{ sredstva.length ? 'Nema sredstava koja odgovaraju odabiru.' : 'Nema nalaza - sva sredstva su uredna.' }}
    </div>

    <!-- popis sredstava -->
    <div v-for="s in redovi" :key="s.kljuc" class="llp-sredstvo">
      <div class="llp-glava" @click="prebaci(s.kljuc)">
        <div class="llp-ime">
          <b>{{ s.naziv || '(bez naziva)' }}</b>
          <span class="llp-mala">šifra int. {{ s.llaID }}<template v-if="s.llaCode"> · AOP {{ s.llaCode }}</template>
            · {{ s.prvaGodina }}–{{ s.zadnjaGodina }}</span>
        </div>
        <div class="llp-razmak"></div>
        <span v-if="s.neobracunato > 0" class="llp-iznos" title="Po stopi je toliko trebalo biti obračunato, a nije">
          nije obračunato {{ novac(s.neobracunato) }}
        </span>
        <span v-if="s.greske.length" class="llp-znak llp-znak-greska">{{ s.greske.length }} greš.</span>
        <span v-if="s.napomene.length" class="llp-znak llp-znak-napomena">{{ s.napomene.length }} nap.</span>
        <button type="button" class="llp-b llp-b-obrub" @click.stop="otvoriKarticu(s)">Kartica</button>
        <span class="llp-strelica">{{ otvoreni.indexOf(s.kljuc) !== -1 ? '▾' : '▸' }}</span>
      </div>

      <table v-if="otvoreni.indexOf(s.kljuc) !== -1" class="llp-tbl">
        <thead>
          <tr><th class="l">God.</th><th class="l">Razina</th><th class="l">Što</th><th class="l">Nalaz</th><th>Iznos</th></tr>
        </thead>
        <tbody>
          <tr v-for="(n, i) in s.greske.concat(s.napomene)" :key="i" :class="n.razina === 'greska' ? 'llp-r-greska' : ''">
            <td class="l">{{ n.godina || '—' }}</td>
            <td class="l"><span class="llp-znak" :class="n.razina === 'greska' ? 'llp-znak-greska' : 'llp-znak-napomena'">{{ n.razina }}</span></td>
            <td class="l">{{ nazivVrste(n.vrsta) }}</td>
            <td class="l">{{ n.poruka }}</td>
            <td class="num">{{ n.iznos === null ? '' : novac(n.iznos) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <v-snackbar v-model="poruka" bottom :timeout="3000" color="red">{{ tekstPoruke }}</v-snackbar>
  </div>
</template>

<script>
// Provjera obracuna amortizacije za SVA osnovna sredstva firme.
//
// Racun je na posluzitelju ("helpers/llaProvjera.js", ruta
// /mainledgerlla/provjera) - ovdje se samo prikazuje, da se brojke na ekranu i
// one u provjeri ne mogu raziti.
//
// Nalazi su na dvije razine i to je glavna poruka ekrana: "greska" znaci da
// racun ne stoji, "napomena" je poslovna odluka ili dogadaj. Amortizacija se
// zna ne obracunati zbog rezultata poslovanja, pa izostanak NIJE greska - ali
// se iznos koji je po stopi trebao biti obracunat uvijek pokazuje.

import MainLedgerLLAService from '@/services/MainLedgerLLAService'
import xlsx from 'json-as-xlsx'
import dayjs from 'dayjs'

// Nazivi i objasnjenja vrsta nalaza. Kljucevi dolaze s posluzitelja; sto ovdje
// nije opisano prikaze se kakvo jest, da se nova vrsta ne izgubi iz vida.
const VRSTE = {
  'prijenos': {naziv: 'Prijenos stanja', opis: 'Neto na početku godine nije neto s kraja prethodne, a nabavna vrijednost se nije mijenjala.'},
  'prijenos-ispravka': {naziv: 'Prijenos ispravka', opis: 'Ispravak na početku godine nije ispravak s kraja prethodne.'},
  'aritmetika-kraj': {naziv: 'Račun na kraju', opis: 'Neto na kraju nije nabavna umanjena za ispravak na kraju.'},
  'aritmetika-pocetak': {naziv: 'Račun na početku', opis: 'Neto na početku nije nabavna umanjena za ispravak na početku.'},
  'ispod-nule': {naziv: 'Ispod nule', opis: 'Neto vrijednost na kraju godine je negativna.'},
  'preko-neta': {naziv: 'Više od neta', opis: 'Amortizacija je veća od neto vrijednosti na početku godine.'},
  'rupa': {naziv: 'Nedostaje godina', opis: 'Između dvije godine sredstva nedostaje poslovna godina.'},
  'bez-amortizacije': {naziv: 'Bez amortizacije', opis: 'Amortizacija nije obračunata iako sredstvo ima vrijednost. Zna se izostaviti zbog rezultata poslovanja - iznos pokazuje koliko bi bilo po stopi.'},
  'odstupanje-stope': {naziv: 'Odstupanje od stope', opis: 'Obračunata amortizacija razlikuje se od one po stopi.'},
  'bez-stope': {naziv: 'Bez stope', opis: 'Sredstvo ima vrijednost, a nema upisanu stopu amortizacije.'},
  'iskljuceno': {naziv: 'Isključeno', opis: 'Sredstvo je označeno kao isključeno iz obračuna, a ima vrijednost.'},
  'nabavna-promijenjena': {naziv: 'Promjena nabavne', opis: 'Nabavna vrijednost se promijenila između godina - rashod, prodaja dijela ili dopuna.'},
  'rashod': {naziv: 'Rashod', opis: 'Rashod ili prodaja - nabavna vrijednost je negativna.'},
  'stopa-promijenjena': {naziv: 'Promjena stope', opis: 'Stopa amortizacije se mijenjala kroz godine.'},
  'preracun-eur': {naziv: 'Preračun u eure', opis: 'Prelazak s kune na euro 2023. - vrijednosti su podijeljene tečajem, nije promjena vrijednosti.'}
}

export default {
  name: 'MainLedgerLLAProvjera',
  data () {
    return {
      sredstva: [],
      sazetak: null,
      otvoreni: [],
      filtar: 'greske',
      trazi: '',
      trazim: false,
      greska: '',
      poruka: false,
      tekstPoruke: '',
      filtri: [
        {vrijednost: 'greske', naziv: 'Samo greške'},
        {vrijednost: 'sve', naziv: 'Greške i napomene'},
        {vrijednost: 'neobracunato', naziv: 'Neobračunata amortizacija'}
      ]
    }
  },
  computed: {
    redovi () {
      const pojam = String(this.trazi || '').trim().toLowerCase()
      let popis = this.sredstva
      if (this.filtar === 'greske') { popis = popis.filter(s => s.greske.length > 0) }
      if (this.filtar === 'neobracunato') { popis = popis.filter(s => s.neobracunato > 0) }
      if (String(this.filtar).indexOf('vrsta:') === 0) {
        const v = String(this.filtar).substring(6)
        popis = popis.filter(s => s.greske.concat(s.napomene).some(n => n.vrsta === v))
      }
      if (pojam) {
        popis = popis.filter(s =>
          String(s.naziv || '').toLowerCase().indexOf(pojam) !== -1 ||
          String(s.llaID).indexOf(pojam) !== -1 ||
          String(s.llaCode || '').toLowerCase().indexOf(pojam) !== -1)
      }
      return popis
    }
  },
  mounted () {
    this.ucitaj()
  },
  methods: {
    novac (v) {
      const n = Number(v) || 0
      return n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    nazivVrste (v) {
      return VRSTE[v] ? VRSTE[v].naziv : v
    },
    opisVrste (v) {
      return VRSTE[v] ? VRSTE[v].opis : v
    },
    async ucitaj () {
      if (!this.$store.state.companyid) {
        this.greska = 'Nije odabrana tvrtka.'
        return
      }
      this.trazim = true
      this.greska = ''
      try {
        // Uvijek se trazi SVE; filtriranje je na ekranu, da prebacivanje
        // izmedju "samo greske" i "sve" ne ide ponovno na posluzitelj.
        const {data} = await MainLedgerLLAService.provjera({CompanyId: this.$store.state.companyid})
        this.sredstva = (data && data.sredstva) || []
        this.sazetak = (data && data.sazetak) || null
        this.otvoreni = []
        // Kad ih je malo, odmah se otvore - inace treba klikati bez potrebe.
        if (this.redovi.length && this.redovi.length <= 5) {
          this.otvoreni = this.redovi.map(s => s.kljuc)
        }
      } catch (err) {
        this.sredstva = []
        this.sazetak = null
        this.greska = 'Provjera nije napravljena: ' + (err && err.message ? err.message : err)
      }
      this.trazim = false
    },
    primijeni () {
      this.otvoreni = []
    },
    filtrirajVrstu (v) {
      this.filtar = this.filtar === 'vrsta:' + v ? 'sve' : 'vrsta:' + v
      this.otvoreni = []
    },
    prebaci (kljuc) {
      const i = this.otvoreni.indexOf(kljuc)
      if (i === -1) { this.otvoreni.push(kljuc) } else { this.otvoreni.splice(i, 1) }
    },
    otvoriKarticu (s) {
      this.$router.push({name: 'mainledgerLLAKartica', query: {llaID: String(s.llaID)}})
    },
    natrag () {
      this.$router.push({name: 'mainledgerLLA'})
    },
    izvezi () {
      // Jedan redak po nalazu - tako se moze sortirati i filtrirati u Excelu.
      const redci = []
      this.redovi.forEach(s => {
        s.greske.concat(s.napomene).forEach(n => {
          redci.push({
            Sifra: s.llaID,
            AOP: s.llaCode,
            Naziv: s.naziv,
            Godina: n.godina,
            Razina: n.razina,
            Vrsta: this.nazivVrste(n.vrsta),
            Nalaz: n.poruka,
            Iznos: n.iznos,
            NeobracunatoSredstvo: s.neobracunato
          })
        })
      })
      if (!redci.length) {
        this.tekstPoruke = 'Nema nalaza za izvoz.'
        this.poruka = true
        return
      }
      const comp = this.$store.state.companyActiv || {}
      const eur = {format: '€#,##0.00'}
      xlsx([{
        sheet: 'Provjera amortizacije',
        columns: [
          {label: 'Šifra int.', value: 'Sifra'},
          {label: 'AOP', value: 'AOP'},
          {label: 'Naziv', value: 'Naziv'},
          {label: 'Godina', value: 'Godina'},
          {label: 'Razina', value: 'Razina'},
          {label: 'Vrsta', value: 'Vrsta'},
          {label: 'Nalaz', value: 'Nalaz'},
          {label: 'Iznos', value: 'Iznos', ...eur},
          {label: 'Nije obračunato (sredstvo)', value: 'NeobracunatoSredstvo', ...eur}
        ],
        content: redci
      }], {
        fileName: (comp.CompanyNameDatabase || '') + '_ProvjeraAmortizacije_' +
          dayjs().format('DD_MM_YYYY_HH_mm'),
        extraLength: 3,
        writeOptions: {}
      })
    }
  }
}
</script>

<style scoped>
.llp { --plava: #1976d2; --crta: rgba(0,0,0,.12); --sivo: rgba(0,0,0,.6);
  --zelena: #2e7d32; --crvena: #c62828; --zuta-sv: #fff4e0; --zuta: #b26a00;
  max-width: 1200px; margin: 0 auto; padding: 4px 0 70px; font-size: 15px; }
.llp-razmak { flex: 1; }
.llp-traka { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; background: var(--plava); color: #fff; border-radius: 4px; padding: 10px 14px; margin-bottom: 10px; }
.llp-naslov { font-size: 20px; font-weight: 700; line-height: 1.2; }
.llp-pod { font-size: 13px; opacity: .9; margin-top: 2px; }
.llp-b { font-family: inherit; font-size: 14px; font-weight: 500; border-radius: 4px; padding: 7px 14px; cursor: pointer; border: 1px solid transparent; }
.llp-b-bijeli { background: #fff; color: var(--plava); }
.llp-b-bijeli[disabled] { opacity: .55; cursor: not-allowed; }
.llp-b-obrub { background: #fff; color: var(--plava); border-color: var(--plava); font-size: 13px; padding: 4px 10px; }
.llp-odabir { background: #fff; border: 1px solid var(--crta); border-radius: 4px; padding: 10px 14px; margin-bottom: 10px; }
.llp-mala { color: var(--sivo); font-size: 13px; }
.llp-crveno { color: var(--crvena); }
.llp-zuto { color: var(--zuta); }
.llp-greska { margin: 8px 0; padding: 8px 12px; border: 1px solid #e0b4a8; background: #fbeeea; color: #8c2f1e; }
.llp-prazno { padding: 24px; text-align: center; color: var(--sivo); }

.llp-brojke { display: flex; flex-wrap: wrap; gap: 14px 26px; background: #fff; border: 1px solid var(--crta); border-radius: 4px; padding: 10px 16px; margin-bottom: 10px; }
.llp-brojke span { display: block; font-size: 12px; color: var(--sivo); line-height: 1.2; }
.llp-brojke b { font-size: 19px; font-variant-numeric: tabular-nums; }
.llp-brojke .llp-ok b { color: var(--zelena); }
.llp-brojke .llp-los b { color: var(--crvena); }
.llp-brojke .llp-istaknuto b { color: var(--zuta); }

.llp-vrste { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 10px; }
.llp-znak { font-size: 12px; border-radius: 10px; padding: 2px 9px; border: 1px solid transparent; cursor: default; }
.llp-znak-greska { background: #fbeeea; color: var(--crvena); border-color: #e9c6bd; }
.llp-znak-napomena { background: var(--zuta-sv); color: var(--zuta); border-color: #e8d2a8; }
.llp-vrste .llp-znak { cursor: pointer; }
.llp-znak-odabran { outline: 2px solid var(--plava); }

.llp-sredstvo { background: #fff; border: 1px solid var(--crta); border-radius: 4px; margin-bottom: 6px; }
.llp-glava { display: flex; align-items: center; gap: 10px; padding: 8px 14px; cursor: pointer; }
.llp-glava:hover { background: #f7f9fb; }
.llp-ime b { margin-right: 8px; }
.llp-iznos { font-size: 13px; color: var(--zuta); font-variant-numeric: tabular-nums; }
.llp-strelica { color: var(--sivo); width: 14px; text-align: center; }

.llp-tbl { border-collapse: collapse; width: 100%; font-size: 13px; border-top: 1px solid var(--crta); }
.llp-tbl th { font-size: 11px; font-weight: 600; color: var(--sivo); text-align: right; padding: 4px 10px; }
.llp-tbl td { padding: 4px 10px; border-top: 1px solid #eef1f4; vertical-align: top; }
.llp-tbl th.l, .llp-tbl td.l { text-align: left; }
.llp-tbl td.num { text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; }
.llp-tbl tr.llp-r-greska td { background: #fdf6f4; }
</style>
